<template>
    <v-layout justify-center>
        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-img
                class="white--text"
                height="100%"
                width="100%"
                gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                :src="imagem"
            >
                <v-container fill-height class="loginOverlay" autofocus>
                    <v-layout flex align-center justify-center>
                        <v-flex xs12 md8 sm6 lg5 xl4 elevation-6>
                            <v-card>
                                <v-toolbar color="green lighter-4" dark>
                                    <span class="headline">Tchê Tasks</span>
                                    <v-spacer></v-spacer>
                                    <span class="h5">O sistema abagualado</span>
                                </v-toolbar>
                                <v-card-text class="pt-4">
                                    <div>
                                        <v-form v-model="valid" ref="form">
                                            <v-text-field
                                                placeholder="Informe seu email"
                                                v-model="email"
                                                :rules="emailRules"
                                                required
                                            ></v-text-field>
                                            <v-text-field
                                                placeholder="Informe sua senha"
                                                v-model="senha"
                                                min="8"
                                                @keyup.enter.native="submit"
                                                :append-icon="
                                                    !e1
                                                        ? 'visibility'
                                                        : 'visibility_off'
                                                "
                                                @click:append="() => (e1 = !e1)"
                                                :type="e1 ? 'password' : 'text'"
                                                :rules="senhaRules"
                                                required
                                            ></v-text-field>
                                            <v-layout justify-space-between>
                                                <v-btn
                                                    @click="submit"
                                                    :class="{
                                                        'green lighter-4 white--text': valid,
                                                        disabled: !valid,
                                                    }"
                                                    >Acessar</v-btn
                                                >
                                                <!-- <a href="">Esqueci a senha</a> -->
                                            </v-layout>
                                        </v-form>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-img>
        </v-dialog>
    </v-layout>
</template>

<style>
html {
    overflow-y: auto;
}
</style>

<script>
import Utils from "@/utils/Utils.js";
import { EventBus } from "@/EventBus.js";

export default {
    data() {
        return {
            imagem: require("@/assets/wallpaper.jpg"),
            dialog: true,
            valid: false,
            e1: true,
            senha: "",
            senhaRules: [(v) => !!v || "A senha deve ser informada"],
            email: "",
            emailRules: [
                (v) => !!v || "E-mail deve ser informado",
                (v) =>
                    /^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    "E-mail precisa ser válido"
            ]
        };
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                let auth = "Basic " + btoa(this.email + ":" + this.senha);
                this.$session.destroy();
                this.$session.start();
                this.$session.set("Authorization", auth);
                Utils.apiAjax({
                    url: "permissoes/Autenticacao",
                    method: "get",
                    success: (response, rawResponse) => {
                        this.$session.set("Sessao", response.data[0].session);
                        this.$session.set("Conta", response.data[0].contaId);
                        this.$session.set("Nome", response.data[0].nome);
                        this.$router.push("/");
                        EventBus.$emit("showPopUp", {
                            text:
                                "Bem vindo(a) de volta, " +
                                response.data[0].nome
                        });
                        EventBus.$emit("loginSuccessful");
                    },
                    failure: (response, rawResponse) => {
                        if (rawResponse.status === 401) {
                            EventBus.$emit(
                                "showErrorDialog",
                                "Usuário ou senha incorreta"
                            );
                        } else {
                            EventBus.$emit(
                                "showErrorDialog",
                                "Erro comunicar com o servidor"
                            );
                        }
                    }
                });
            }
        }
    },
    mounted() {
        if ( localStorage.getItem("vue-session-solicitacoes-expired") === "EXPIRED" ) {
            EventBus.$emit("showPopUp", {
                text: "A sessão expirou"
            });
        }
        localStorage.removeItem("vue-session-solicitacoes-expired");
        localStorage.removeItem("solicitacoes-parceiros-filterData");
    }
};
</script>